export const UPDATE_EMAIL = 'UPDATE_EMAIL';

// Action creator to update the email
export const updateEmail = (email) => {
  // Save email to localStorage when action is dispatched
  localStorage.setItem('email', email);

  return {
    type: UPDATE_EMAIL,
    payload: email,
  };
};

// Initial state for the email
const initialState = {
  // Load the email from localStorage if available, otherwise use an empty string
  email: localStorage.getItem('email') || '',
};

// Email reducer to handle email-related actions
const emailReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EMAIL:
      return {
        ...state,
        email: action.payload,  // Update email with the new payload
      };
    default:
      return state;
  }
};

export default emailReducer;
